<template>
  <v-select
    id="permissoes-select"
    v-model="filter.permissao"
    item-text="nome"
    item-name="permissaoId"
    :items="permissoes"
    label="Permissão"
    placeholder="Permissão"
    @change="$emit('changePermission')"
    :return-object="true"
  >
    <template slot="no-data">
      Nenhuma Permissão retornada
    </template>
  </v-select>
</template>

<script>
import { permissionAPI } from '../PermissionAPI'

export default {
  name: 'AppPermissionCombobox',
  props: [
    'filter'
  ],
  mounted () {
    this.loadPermissions()
  },
  methods: {
    loadPermissions () {
      permissionAPI.list()
        .then(resp => {
          this.permissoes = resp.data
        })
        .catch()
    }
  },
  data () {
    return {
      permissoes: []
    }
  }
}
</script>
